import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiRating: {
    styleOverrides: ComponentsOverrides<Theme>['MuiRating'];
    defaultProps?: ComponentsProps['MuiRating'];
} = {
    styleOverrides: {
        icon: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
                fontSize: 24,
            },
        }),
        iconEmpty: ({ theme }) => ({
            color: theme.palette.grey[800],
        }),
    },
};
